export const setOrgActiveFlag = (state, isActive) => {
  state.isOrgActive = isActive;
};
export const setCalendarDate = (state, date) => {
  state.calendarDate = date;
};

export const setOverviewScrollPosition = (state) => {
  state.overviewScrollPositionTop = window.scrollY || 0;
  const scrollTarget = document.querySelector('.calendar-scroll-target');
  if (scrollTarget) {
    state.overviewScrollPositionLeft = document.querySelector('.calendar-scroll-target').scrollLeft;
  } else {
    state.overviewScrollPositionLeft = 0;
  }
};

export const setTodaysDate = (state, todaysDate) => {
  state.todaysDate = todaysDate;
};
